import React from 'react';
import {Tabs} from 'antd';
import NodeList from './NodeList'

const { TabPane } = Tabs;
class NodeManage extends React.Component{
  
    constructor(props) {
      super(props);  
      this.state={
        activeKey:"1",
        isfalse:null,
      }
    }
      callback(activeKey,type,params){
          if(type == "details"){
            this.state.isfalse=true;
            this.state.params = params
          }
          if(type == "add"){
            this.state.params = null
            this.state.isfalse=false;
          }
        this.setState({activeKey:activeKey})
      }
    render(){
      const {isfalse}=this.state
        return(
          <div>
           <Tabs type="card" activeKey={this.state.activeKey} onChange= {this.callback.bind(this)}>
            <TabPane tab="节点列表" key="1">
              <NodeList  buttonList={this.props.buttonList} callback = {this.callback.bind(this)}/>
            </TabPane>
          </Tabs> 
          </div>
        )
    }
}
export default NodeManage;